import React, { useCallback, useRef, useState } from "react";
import "swiper/css";
import "swiper/css/effect-cards";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCards } from "swiper";
import avatar from "../../../assets/img/Home/avatar.png";
import comma from "../../../assets/img/icons/،،.svg";
import { Navigation, Pagination } from "swiper";
import { SampleNextArrow, SamplePrevArrow } from "../../shared/Arrow";
import "swiper/css/navigation";
import flash from "../../../assets/img/Home/Vector 17.svg";
import useFetch from "../../../hooks/useAxios";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

const Commentbox = ({ info }) => {
  return (
    <div className="comment-box">
      <div className="flex justify-between items-center">
        <div className="flex">
          <img src={info.author.avatar} className='comment-box--avatar' />
          <div className="mr-[10px]">
            <div className="text-[#292D32] comment-box--name font-[500] text-[24px]">
              {info.author.full_name}
            </div>
            <div className="text-[#797D82] comment-box--role text-[18px] ont-[400]">
              {info.author.role}
            </div>
          </div>
        </div>
        <img src={comma} />
      </div>
      <p className="text-[24px] text-[#292D32] font-[500] mt-[36px]">
        {info.body}
      </p>
    </div>
  );
};
const Commentbyother = () => {
  const sliderRef = useRef(null);

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slideNext();
  }, []);
  const [infoHome, setinfoHome] = useState([]); //city //start //end //count
  const apiGetHomeInfo = useFetch({
    method: "get",
    url: "api/home/feedbacks",
    noHeader: true,
    trigger: true,
    argFunc: res => setinfoHome(res.data)
  });

  return (
    <div className="container">
      <div className="comment">
        <h3 className="comment-title">نظرات همراهان</h3>
        <div className="comment-conatiner flex justify-between items-cente">
          <div>
            <h3 className="text-[#292D32] font-[900] text-[40px]">
              در مورد جاتیک چه می شنویم ؟{" "}
            </h3>
            <p className="text-[#292D32] font-[500] text-[20px] my-[20px] w-[73%] z-[999] relative comment__p">
              این‌ها، تنها بخش خیلی کوچکی از نظراتی هستند که افراد مختلف از
              میزبانان و کاربران می باشد که در مورد جاتیک ابراز کرده اند
            </p>
            <div>
              <div>
                <div className="flex justify-between w-[65%] comment__footer">
                  <div className="flex mt-[10px]">
                    <SampleNextArrow
                      onClick={handleNext}
                      className="icons-transparent"
                    />
                    <SamplePrevArrow
                      onClick={handlePrev}
                      className="icons-transparent"
                    />
                  </div>
                  <img src={flash} className='comment__flash'/>
                </div>
              </div>
            </div>
          </div>
          <div>
            {infoHome
              ? <Swiper
                  effect={"cards"}
                  //grabCursor={true}
                  modules={[EffectCards]}
                  className="mySwiper"
                  ref={sliderRef}
                >
                  {infoHome.map(i =>
                    <SwiperSlide key={i.id}>
                      <Commentbox  info={i} />
                    </SwiperSlide>
                  )}
                </Swiper>
              : <SkeletonTheme height={200} borderRadius={10}>
                  <div className="grid grid-cols-1 gap-[20px]">
                    <Skeleton />
                  </div>
                </SkeletonTheme>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Commentbyother;
